import React from 'react';
import { DefaultWidgetWithHeader } from '../../_lib/components/Widget';
import { Widget as WidgetShape } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { Icons } from '../../components/atoms/SVG';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { isEmptyBlock } from '../../types/api/Block';
import { StructuralPageToPageTreeBlock } from '../../_blocks/StructuralPageToPageTree';

type StructuralPageToPageTreeWidget = WidgetShape<[StructuralPageToPageTreeBlock], WidgetType.structuralPageToPageTree>;

export function StructuralPageToPageTreeWidget({
  blocks,
  elementType,
  ...headerProps
}: StructuralPageToPageTreeWidget) {
  const { t } = useSonTranslation('PageToPage');

  if (isEmptyBlock(blocks[0])) {
    return null;
  }

  return (
    <DefaultWidgetWithHeader
      {...headerProps}
      widgetType={elementType}
      icon={Icons.CONNECTIONS}
      title={t('widgetTitle.structuralPageToPage')}
    >
      <StructuralPageToPageTreeBlock {...blocks[0]} />
    </DefaultWidgetWithHeader>
  );
}
